import { Alert, Typography } from '@montugroup/design-system';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { Box, Grid } from '@mui/material';

const BannerAction = () => {
  const handleScrollToAndAnimate = () => {
    const el = document.getElementById('consultation-save-btn');

    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });

      el.classList.add('blink-animation');

      setTimeout(() => {
        el.classList.remove('blink-animation');
      }, 2500);
    }
  };

  return (
    <Typography
      color="info.main"
      sx={{ cursor: 'pointer', ':hover': { fontWeight: 600 }, minWidth: '125px' }}
      onClick={handleScrollToAndAnimate}
    >
      Go to save button
    </Typography>
  );
};

const ConsultationSaveButtonBanner = () => {
  return (
    <Grid item xs={12} marginTop={4} marginBottom={4}>
      <Alert
        icon={<InfoOutlineIcon fontSize="inherit" />}
        severity="info"
        sx={{ width: '100%' }}
        action={<BannerAction />}
      >
        <Box display="flex" flexDirection="row" width="100%" justifyContent="space-between">
          <Box gap={1} display="flex" flexDirection="column">
            <Typography fontWeight={600}>Reminder</Typography>
            <Typography>
              You still need to <strong>press save</strong> in this consultation section if you want to back up your
              work here.
            </Typography>
          </Box>
        </Box>
      </Alert>
    </Grid>
  );
};

export default ConsultationSaveButtonBanner;
